import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import habitsReducer from './slices/habitsSlice';
import recordsReducer from './slices/recordsSlice';
import uiReducer from './slices/uiSlice';

/**
 * Redux Store 設定 (Local First 統合版)
 * redux-persist を廃止し、IndexedDB を唯一のデータソースとします。
 * UIの状態遷移のみを管理し、永続化は各 Slice の AsyncThunk で明示的に IndexedDB に行います。
 */

const rootReducer = combineReducers({
  habits: habitsReducer,
  records: recordsReducer,
  ui: uiReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Date型などを扱うため
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
